import { FC, MouseEvent, useRef } from 'react'
import { StyledButton, StarsWrapper, Star } from './styles'
import { useDialog } from 'src/shared/hooks'

interface QuoteButtonProps {
  modalReq: ReturnType<typeof useDialog>
  handleClose: () => void
}

export const QuoteButton: FC<QuoteButtonProps> = (props) => {
  const glowRef = useRef<HTMLDivElement>(null)

  const handleMouseMove = (e: MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    if (glowRef.current) {
      glowRef.current.style.left = `${x}px`
      glowRef.current.style.top = `${y}px`
    }
  }

  return (
    <StyledButton
      onMouseMove={handleMouseMove}
      onClick={() => {
        props.modalReq.handleOpen()
        props.handleClose()
      }}
    >
      <div className="glow" ref={glowRef} />
      <span>Cotizar</span>
      <StarsWrapper>
        <Star src="/images/home2/sparkle.svg" width="16" height="16" />
      </StarsWrapper>
    </StyledButton>
  )
}
